import { render, staticRenderFns } from "./BacklogTimeReport.vue?vue&type=template&id=508e694c&scoped=true&"
import script from "./BacklogTimeReport.vue?vue&type=script&lang=js&"
export * from "./BacklogTimeReport.vue?vue&type=script&lang=js&"
import style0 from "./BacklogTimeReport.vue?vue&type=style&index=0&id=508e694c&scoped=true&lang=css&"
import style1 from "./BacklogTimeReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e694c",
  null
  
)

export default component.exports